import React, { FC } from 'react';
import { Skeleton, Stack, useTheme } from '@mui/material';
import { DashboardCard } from '@monorepo/nova-ui';

export const ObjectiveListSkeleton: FC = () => {
  const theme = useTheme();

  const ObjectiveItemSkeleton = () => (
    <Stack gap={2} flex={1} minWidth={0}>
      {/* Icon and title row */}
      <Stack direction="row" alignItems="center" gap={2}>
        <Skeleton variant="circular" width={24} height={24} />
        <Skeleton variant="text" width={120} height={20} />
      </Stack>

      {/* Value and subtitle */}
      <Stack gap={1}>
        <Skeleton
          variant="text"
          width={100}
          height={theme.typography.pxToRem(20)}
        />
        <Skeleton variant="text" width={80} height={16} />
      </Stack>
    </Stack>
  );

  return (
    <DashboardCard
      minWidth={{
        xs: 100,
        sm: 150,
        md: 200,
      }}
    >
      <Stack
        direction={{
          sm: 'column',
          md: 'row',
        }}
        flexWrap="wrap"
        width="100%"
        alignItems="flex-start"
        gap={5}
      >
        {/* First row of objectives */}
        <Stack direction="row" flex={1} gap={5}>
          <ObjectiveItemSkeleton />
          <ObjectiveItemSkeleton />
        </Stack>

        {/* Second row of objectives */}
        <Stack direction="row" flex={1} gap={1}>
          <ObjectiveItemSkeleton />
          {/* Payout objective with button */}
          <Stack gap={2} flex={1} minWidth={0}>
            <Stack direction="row" alignItems="center" gap={2}>
              <Skeleton variant="circular" width={24} height={24} />
              <Skeleton variant="text" width={100} height={20} />
            </Stack>
            <Stack gap={2}>
              <Skeleton
                variant="text"
                width={120}
                height={theme.typography.pxToRem(20)}
              />
              <Skeleton variant="rounded" width={100} height={32} />
            </Stack>
          </Stack>
        </Stack>
      </Stack>
    </DashboardCard>
  );
};
